import axios from ".";

/** Search milestones for dashboard display. */
export const getAllMilestones = (data: any) => {
  return axios({
    method: "POST",
    url: `/milestone/milestones`,
    data: data,
  });
};
export const getClearedMilestones = (data: any) => {
  return axios({
    method: "GET",
    url: `/milestone/milestones/cleared`,
    params: data,
  });
};

/** Create a milestone. */
export const addMilestones = (data: any) => {
  return axios({
    method: "POST",
    url: `/milestone/create-milestone`,
    data: data,
  });
};

/** Update milestone by id. */
export const updateMilestones = (id: number, data?: any) => {
  return axios({
    method: "PUT",
    url: `/milestone/${id}`,
    data: data,
  });
};

/** Delete a milestone by id. */
export const deleteMilestonesByID = (id: number | null) => {
  return axios({
    method: "DELETE",
    url: `/milestone/${id}`,
  });
};

/** Get departments related to an initiative's milestones. */
export const getMilestoneDepartmentsForInitiative = (initiativeId: any) => {
  return axios({
    method: "GET",
    url: `/milestone/departments/active?initiativeId=${initiativeId}`,
  });
};

/** Get a milestone by id. */
export const getMilestoneById = (initiativeId: any) => {
  return axios({
    method: "GET",
    url: `/milestone/${initiativeId}`,
  });
};
